<template>
  <div v-if="false && !loading">
    <iframe :src="userUrl + '/user/sync'" v-if="!frameElement && !isUsers" frameborder="0" width="0" height="0" id="userFrame" name="userFrame"></iframe>
    <iframe :src="ctcUrl" v-if="!frameElement && isUsers && !isCTC" frameborder="0" width="0" height="0" id="ctcFrame" name="ctcFrame"></iframe>
    <iframe :src="accUrl" v-if="!frameElement" frameborder="0" width="0" height="0" id="accFrame" name="accFrame"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      ctcUrl: undefined,
      userUrl: undefined,
      accUrl: undefined,
      frameElement: false
    }
  },
  computed: {
    isUsers() {
      const host = window.location.host;
      const parts = host.split('.');
      if (parts[0] == "users" || parts[0] == "users-staging")
        return true;
      else
        return false;
    },
    isCTC() {
      const host = window.location.host;
      const parts = host.split('.');
      return parts[0] == "localhost:8080" || parts[0] == "ctc-compliance-index" || parts[0] == "ctc-staging" || parts[0] == "indices";
    }
  },
  methods: {
    SetupListener() {
      var self = this;
      const ctcUrl = this.ctcUrl;
      const userUrl = this.userUrl;
      const accUrl = this.accUrl;
      window.onmessage = function (e) {
        //console.log("origin", e.origin)
        if (e.origin !== ctcUrl && e.origin !== userUrl && e.origin !== accUrl) {
          console.error("Invalid Origin.");
          return;
        }

        try {
          //console.log("data", e.data)
          var payload = JSON.parse(e.data);

          if (payload.ACTION === "LOGIN") {
            if (payload.CTC_USER)
              localStorage.setItem("CTC_USER", payload.CTC_USER);
            if (payload.CTC_AUTH_TOKEN)
              localStorage.setItem("CTC_AUTH_TOKEN", payload.CTC_AUTH_TOKEN);
            if (payload.CTC_REFRESH_TOKEN)
              localStorage.setItem("CTC_REFRESH_TOKEN", payload.CTC_REFRESH_TOKEN);
          }
          else if (payload.ACTION === "LOGOUT") {
            self.$store.dispatch('silent_logout');
          }
        }
        catch (err) {
          //console.error(err);
        }
      }
    }
  },
  mounted() {
    this.frameElement = window.frameElement;

    this.ctcUrl = process.env.VUE_APP_CTCUrl;
    this.userUrl = process.env.VUE_APP_UserUrl;
    this.accUrl = process.env.VUE_APP_CarbonCalculatorUrl;
    this.loading = false;

    this.$nextTick(() => {
      this.SetupListener();
    });
  }
}
</script>
